window.site = (window.site || {});

/**
 * Init Spaces Galleries with Swiper
 * @class SpacesGalleries
 * @static
 */
site.SpacesGalleries = (function SpacesGalleries() {

  'use strict';

  var inited = false;

  function initSwiper(container) {
    if (!container) return null;

    const images = Array.from(container.querySelectorAll('img'));
    if (images.length === 0) return null;

    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    images.forEach((img) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(img.cloneNode(true));
      wrapper.appendChild(slide);
    });

    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }

    container.classList.add('swiper');
    container.appendChild(wrapper);

    const prevBtn = document.createElement('div');
    prevBtn.className = 'swiper-button-prev';
    container.appendChild(prevBtn);

    const nextBtn = document.createElement('div');
    nextBtn.className = 'swiper-button-next';
    container.appendChild(nextBtn);

    return new window.Swiper(container, {
      modules: [window.SwiperModules.Navigation],
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });
  }

  var init = function () {
    if (inited) return false;
    inited = true;

    const $spaces = document.querySelectorAll('.space-gallery');

    $spaces.forEach(($space) => {
      initSwiper($space);
    });

    return true;
  };

  return {
    init: init,
  };

}());
